import React from 'react';
import './BlogPost.css';

import logo from '../../images/blog-2019-sommerfest-bgb.jpeg';

class BlogPost4 extends React.Component {
  render() {
    return (
    <div className="blogpost-outer">
      <div className="blogpost-title">
        <h3 className="blogpost-h3" >Sommerfest BGB!     -     08. September 2019</h3>
      </div>
      <div className="blogpost-content">
        <div className="blogpost-image">
          <img className="image-fit" alt="Sommerfest BGB" src={logo}/>
        </div>
        <div className="blogpost-text">
          Hey, Hey & Hey, 
          <p>wir haben am vergangenen Freitag mit den Red Lines feat. Horns das Sommerfest des Schützenvereins BGB in Alstätte begleitet.</p> 
          Die Stimmung war den ganzen Abend einfach atemberaubend! <br/> Vielen Dank, dass ihr so ausgelassen mit uns gefeiert habt!
        </div>

      </div>
    </div>
    )
  }
}

export default BlogPost4;


// WEBPACK FOOTER //
// ./src/components/blog/BlogPost4.js